import { useState, useEffect } from 'react';

interface NetworkStatus {
  isOnline: boolean;
  isWeak: boolean;
}

const weakConnectionTypes: string[] = ['slow-2g', '2g'];

export const useNetworkStatus = (): NetworkStatus => {
  const [networkStatus, setNetworkStatus] = useState<NetworkStatus>(() => {
    const isOnline = navigator.onLine;
    const connection = (navigator as any).connection;
    const isWeak = connection ? weakConnectionTypes.includes(connection.effectiveType) : false;
    return { isOnline, isWeak };
  });

  useEffect(() => {
    const handleOnline = () => {
      setNetworkStatus(prevStatus => ({ ...prevStatus, isOnline: true }));
    };

    const handleOffline = () => {
      setNetworkStatus(prevStatus => ({ ...prevStatus, isOnline: false, isWeak: false })); 
    };

    const handleConnectionChange = () => {

      const connection = (navigator as any).connection;
      if (connection) {
        const effectiveType = connection.effectiveType;
        setNetworkStatus(prevStatus => ({
          ...prevStatus,
          isWeak: weakConnectionTypes.includes(effectiveType),
        }));
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    const connection = (navigator as any).connection;
    if (connection) {
      connection.addEventListener('change', handleConnectionChange);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if (connection) {
        connection.removeEventListener('change', handleConnectionChange);
      }
    };
  }, []);

  return networkStatus;
};